/**
 * Mise en forme des témoignages pour la grille de l'Accueil.
 *
 * La ponctuation appartient à l'affichage, pas à la saisie : la gérante colle
 * le texte d'un avis, elle n'a pas à se demander s'il faut ouvrir des
 * guillemets ni lesquels. Le site les pose, toujours les mêmes.
 *
 * Et surtout elle ne doit pas être punie de les avoir mis. Un avis copié
 * depuis Google arrive très souvent déjà entouré de guillemets — droits,
 * courbes ou français selon la plateforme. Sans le nettoyage ci-dessous, la
 * grille afficherait « "Un accueil chaleureux." » avec deux paires
 * imbriquées.
 */

// Guillemets de toutes provenances, plus les espaces qui les collent :
// droits ("), courbes (“ ”), français (« »), et l'apostrophe droite (')
// qu'on retrouve parfois en guise de guillemet simple.
const GUILLEMETS_EN_TETE = /^[\s"“”«»'‘’]+/
const GUILLEMETS_EN_FIN = /[\s"“”«»'‘’]+$/

// Tirets d'attribution déjà présents dans la saisie : cadratin, demi-cadratin
// ou simple trait d'union, suivis de leur espace.
const TIRET_EN_TETE = /^[\s—–-]+/

/**
 * La citation telle qu'elle s'affiche : une seule paire de guillemets
 * français, quelle que soit la forme de la saisie.
 *
 * Rend une chaîne vide pour une saisie vide plutôt que « » — une paire de
 * guillemets sans contenu est un artefact, pas un témoignage. Le cas ne
 * devrait pas se produire (le schéma refuse une citation vide), mais un
 * contenu déjà en base peut avoir été écrit avant ce schéma.
 *
 * Les espaces intérieurs sont INSÉCABLES (U+00A0), là où le JSX d'origine
 * posait des espaces ordinaires. La typographie française les impose, et la
 * grille de témoignages est le pire endroit pour s'en passer : trois colonnes
 * étroites, donc un retour à la ligne possible juste après le guillemet
 * ouvrant, qui resterait alors seul en bout de ligne.
 */
export function citation(texte) {
  const nettoye = String(texte ?? '')
    .replace(GUILLEMETS_EN_TETE, '')
    .replace(GUILLEMETS_EN_FIN, '')
  return nettoye ? `« ${nettoye} »` : ''
}

/**
 * La signature telle qu'elle s'affiche : un cadratin, un espace, le nom.
 * Le tiret est retiré de la saisie s'il s'y trouve, pour ne pas obtenir
 * « — — Camille D. ».
 */
export function signature(nom) {
  const nettoye = String(nom ?? '').replace(TIRET_EN_TETE, '').trim()
  return nettoye ? `— ${nettoye}` : ''
}
